/**
 * 手当申請
 * 手本: src/domain/master/attend/attendOvertimeApplication.ts
 * 相違: 申請値を明細（detailList）で N 件持つ
 */

/** 手当申請の明細1行（手当マスタの表示情報＋申請値） */
export interface AllowanceDetail {
  allowanceId: string,
  allowanceCode: string,
  allowanceName: string,
  /** 申請時表示メッセージ（「申請内容」列） */
  dispMessage: string,
  /** 申請時表示単位（円・回など。表示専用） */
  dispUnit: string,
  /** 申請値（未申請なら null） */
  allowanceValue: number | null,
  comment: string,
}

/** 更新履歴タブの1行 */
export interface AllowanceHistory {
  version: number,
  applicationDate: string,
  applicationStaffCode: string,
  applicationStaffName: string,
  applicationStatus: number,
  modifiyStatus: number,
  applicationReason: string,
  rejectReason: string,
  approvalDate: string,
  approvalStaffCode: string,
}

export interface AllowanceApplication {
  modifierApplicationId: string,
  staffCode: string,
  staffName: string,
  orgCode: string,
  orgName: string,
  targetDate: string,
  targetDateStr: string,
  version: number | null,
  buttonType: number,
  applicationReason: string,
  applicationStatus: any,
  modifiyStatus: any,
  approvalStaffCode: string,
  approvalStaffName: string,
  applicationStaffCode: string,
  applicationStaffName: string,
  rejectReason: string,
  deleteAvailable: boolean,
  updateUserCode: string,
  detailList: AllowanceDetail[],
  historyList: AllowanceHistory[],
}

export default class AttendAllowanceApplicationDomain {
  constructor(private rawData: AllowanceApplication) {
    // do nothing
  }

  static generateInitial(): AttendAllowanceApplicationDomain {
    return new AttendAllowanceApplicationDomain({
      modifierApplicationId: '',
      staffCode: '',
      staffName: '',
      orgCode: '',
      orgName: '',
      targetDate: '',
      targetDateStr: '',
      version: null,
      buttonType: 0,
      applicationReason: '',
      applicationStatus: null,
      modifiyStatus: null,
      approvalStaffCode: '',
      approvalStaffName: '',
      applicationStaffCode: '',
      applicationStaffName: '',
      rejectReason: '',
      deleteAvailable: false,
      updateUserCode: '',
      detailList: [],
      historyList: [],
    });
  }

  getRawData(): AllowanceApplication {
    return this.rawData;
  }

  get modifierApplicationId(): string {
    return this.rawData.modifierApplicationId;
  }

  set modifierApplicationId(modifierApplicationId: string) {
    this.rawData.modifierApplicationId = modifierApplicationId;
  }

  get staffCode(): string {
    return this.rawData.staffCode;
  }

  set staffCode(staffCode: string) {
    this.rawData.staffCode = staffCode;
  }

  get staffName(): string {
    return this.rawData.staffName;
  }

  get orgCode(): string {
    return this.rawData.orgCode;
  }

  set orgCode(orgCode: string) {
    this.rawData.orgCode = orgCode;
  }

  get orgName(): string {
    return this.rawData.orgName;
  }

  get targetDateStr(): string {
    return this.rawData.targetDateStr;
  }

  set targetDateStr(targetDateStr: string) {
    this.rawData.targetDateStr = targetDateStr;
  }

  get version(): number | null {
    return this.rawData.version;
  }

  get buttonType(): number {
    return this.rawData.buttonType;
  }

  set buttonType(buttonType: number) {
    this.rawData.buttonType = buttonType;
  }

  get applicationReason(): string {
    return this.rawData.applicationReason;
  }

  set applicationReason(applicationReason: string) {
    this.rawData.applicationReason = applicationReason;
  }

  get applicationStatus(): any {
    return this.rawData.applicationStatus;
  }

  get modifiyStatus(): any {
    return this.rawData.modifiyStatus;
  }

  get rejectReason(): string {
    return this.rawData.rejectReason;
  }

  get deleteAvailable(): boolean {
    return this.rawData.deleteAvailable;
  }

  get updateUserCode(): string {
    return this.rawData.updateUserCode;
  }

  set updateUserCode(updateUserCode: string) {
    this.rawData.updateUserCode = updateUserCode;
  }

  get detailList(): AllowanceDetail[] {
    return this.rawData.detailList || [];
  }

  set detailList(detailList: AllowanceDetail[]) {
    this.rawData.detailList = detailList;
  }

  get historyList(): AllowanceHistory[] {
    return this.rawData.historyList || [];
  }

  /** 申請中かどうか（申請ボタンの活性判定に使う） */
  get isApplying(): boolean {
    return this.rawData.applicationStatus === 0;
  }

  /** 申請キャンセルできるか（申請中のときだけ） */
  get cancelAvailable(): boolean {
    return this.rawData.applicationStatus === 0 && !!this.rawData.modifierApplicationId;
  }
}
